document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-inline-toggle]");
  if (!btn) return;

  const parent = btn.closest("[data-inline-parent]");
  if (!parent) return;

  const panel = parent.querySelector(".mega-inline-submenu");
  if (!panel) return;

  const isOpen = !panel.hasAttribute("hidden");
  if (isOpen) {
    panel.setAttribute("hidden", "");
    btn.setAttribute("aria-expanded", "false");
  } else {
    panel.removeAttribute("hidden");
    btn.setAttribute("aria-expanded", "true");
  }
});
